import React, { useState, useEffect, useCallback } from "react";
import "../../style/css/Membership/joineltai.css";
import "../../style/css/banner.css";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import TopHeader from "../../Component/Header/TopHeader";
import { useLazyGetAllMemberShipDetailsQuery } from "../../app/services/memberShipServices";
import joineltaibackground from "../../assets/images/joinetai/bgimage.png";
import Tooltip from "@mui/material/Tooltip";
import {
  expiredStatus,
  logOut,
  selectCurrentScope,
  setIsExpired,
} from "../../app/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  selectCurrentMember,
  setMemberDetails,
} from "../../app/features/memberSlice";
import { toast } from "react-toastify";
import { useForm, useWatch } from "react-hook-form";
import {
  useLazyGetMemberDetailsByIdQuery,
  useUpdatePlansRenewalMutation,
  useUpdateChangePlanMutation,
  useCancelRenewalMutation,
} from "../../app/services/memberServices";
import {
  Modal,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Container,
  TextField,
} from "@mui/material";
import { planType } from "../../constant/constant";
import { NotificationImportant } from "@material-ui/icons";
import { api } from "../../app/services/api";
import {
  setChapterDetails,
  setRoleDetails,
} from "../../app/features/chapterAdminSlice";
import { setSigDetails, setSigRoleDetails } from "../../app/features/sigSlice";

const JoinEltai = () => {
  const [hoveredPrice, setHoveredPrice] = useState(null);
  const [allMembershipPlans] = useLazyGetAllMemberShipDetailsQuery();
  const dispatch = useDispatch();
  const memberDetails = useSelector(selectCurrentMember);
  const isExpired = useSelector(expiredStatus) === 1;
  const location = useLocation();
  const [subscriptionData, setSubscriptionData] = useState([]);
  const memberScope = useSelector(selectCurrentScope);
  const navigate = useNavigate();
  const [gettMemberDetailsByIdQuery] = useLazyGetMemberDetailsByIdQuery();
  const [updateRenewalPlan] = useUpdatePlansRenewalMutation();
  const [cancelRenewal] = useCancelRenewalMutation();
  const [updateChangePlan, { isLoading: changePlanLoading }] =
    useUpdateChangePlanMutation();
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState("");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [isPlanUpdated, setIsPlanUpdated] = useState(false);
  const [memberPlanType, setMemberPlanType] = useState([]);
  const [disableRenew, setDisableRenew] = useState(false);
  const [hideRenew, setHideRenew] = useState(false);

  const { getValues, setValue, control, register } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      planTypeId: "",
      planId: "",
      amount: "",
      currency: "INR",
      orderId: "",
      paymentStatus: 0,
      memberId: "",
      chapter: "",
    },
  });

  const paymentStatus = useWatch({
    control,
    name: "paymentStatus",
  });



  useEffect(() => {
    if (memberDetails?.type === '4' && isExpired)
      gettMemberDetailsByIdQuery(memberDetails?._id).then(res => {
        if (res?.data?.status) {
          dispatch(setMemberDetails(res?.data?.data))
          const plan = res.data?.data?.plans[res.data?.data?.plans.length - 1];
          const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(plan?.planEndDate);
          if (!planExpired) {
            dispatch(setIsExpired({ expiredMembers: 0 }));
            navigate("/member/teacher-member/" + memberDetails?._id);
          }
        }
      })
  }, [dispatch, memberDetails, gettMemberDetailsByIdQuery, isExpired, navigate])

  //Get all membership plans details
  useEffect(() => {
    allMembershipPlans().then((res) => {
      if (res.data?.status) {
        const data = res.data?.data.filter((plan) => plan.isDeleted === 0);
        if (memberScope === "PORTAL_MEMBER") {
          const found = memberDetails && data.find(
            (plan) =>
              plan?._id ===
              memberDetails?.plans.findLast(pl => pl.isPaid === 1)?.planId
          );
          const disable = memberDetails && isDateWithinThreeMonths(
            memberDetails?.plans.findLast(pl => pl.isPaid === 1)?.planEndDate
          );
          setDisableRenew(disable);
          setSelectedPlan(found);
          const hide =
            found?.planName === "0" && memberDetails &&
            found?.planType.find(
              (item) =>
                item?._id ===
                memberDetails?.plans.findLast(pl => pl?.isPaid === 1)
                  ?.planTypeId
            )?.planTypeName === "Annual";
          setHideRenew(hide);
          setSubscriptionData(found ? [found] : data);
        } else {
          setSubscriptionData(data);
        }
      }
    });
  }, [allMembershipPlans, memberDetails, memberScope, getValues, setValue]);

  function isDateWithinThreeMonths(dateToCompare) {
    const today = new Date();
    const oneMonthsLater = new Date(today);
    oneMonthsLater.setMonth(today.getMonth() + 1);
    const date = new Date(dateToCompare.split('T')[0]);
    oneMonthsLater.setDate(date.getDate());
    return date >= oneMonthsLater;
  }

  useEffect(() => { }, [subscriptionData]);

  //handle payment
  const handlePayment = () => {
    var options = {
      key: process.env.REACT_APP_RAZOR_PAY_KEY_ID, // Enter the Key ID generated from the Dashboard
      amount: getValues("amount"), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: getValues("currency"),
      config: {
        display: {
          hide: [
            { method: "paylater" },
            { method: "emi" },
            { method: "wallet" },
          ],
        },
      },
      name: memberDetails.fullName
        ? memberDetails.fullName
        : memberDetails.firstName + " " + memberDetails.lastName, //your business name
      description: "Membership payment",
      order_id: getValues("orderId"), //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        document.body.style.overflow = "auto";
        gettMemberDetailsByIdQuery(memberDetails?._id).then((res) => {
          if (res.data?.status) {
            if (memberDetails?.type === "0" || memberDetails?.type === '4') {
              navigate("/member/teacher-member/" + memberDetails?._id);
            }
            if (memberDetails?.type === "1") {
              navigate("/member/student-member/" + memberDetails?._id);
            }
            if (memberDetails?.type === "2") {
              navigate("/member/View-institution/" + memberDetails?._id);
            }
            if (memberDetails?.type === "3") {
              navigate("/member/view-corporate/" + memberDetails?._id);
            }
            dispatch(setMemberDetails(res?.data?.data));
            dispatch(setIsExpired({ expiredMembers: 0 }));
            setValue("paymentStatus", res.data?.data?.plans[0].isPaid === 1);
            toast.success("Plan updated successfully");
          }
        });
      },
      modal: {
        ondismiss: function () {
          document.body.style.overflow = "auto";
          setIsPlanUpdated(false);
          cancelRenewal(memberDetails?._id).then((res) => {
            toast.warn("Renewal process is cancelled");
          });
        },
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", function (response) {
      alert("Error in Payment", response.error);
      toast.error("Payment Failed");
    });
    setOpen(false);
    setOpenModal(false);
  };

  //handle mouse enter(hover)
  const handleMouseEnter = (index) => {
    setHoveredPrice(index);
  };

  //news Mouse Leave
  const handleMouseLeave = (index) => {
    setHoveredPrice(null);
  };
  const cancelRenewalFn = useCallback(() => {
    handleClose();
    cancelRenewal(memberDetails?._id).then((res) => {
      toast.warn("Renewal process is cancelled");
    });
  }, [cancelRenewal, memberDetails?._id]);
  //handle Register
  const handleRegister = (planId, planTypeId) => {
    // navigate(`/register/${planId}/${planTypeId}`);
    navigate(`/membershipPage`);
  };

  //Modal usage
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    backgroundColor: "white",
    boxShadow: 24,
    padding: "20px",
  };

  //Modal usage
  const handleOpen = (id) => {
    const data = {
      memberId: id,
    };
    updateRenewalPlan(data).then((res) => {
      if (res?.data?.status) {
        setOpen(true);
        const data = res?.data?.data?.purchaseData;
        setValue("amount", data?.amount);
        setValue("currency", data?.currency);
        setValue("orderId", data?.orderId);
      }
    });
  };

  //handleClose
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpen(false);
  };

  //handleopen model
  const handleOpenModal = (id) => {
    setOpenModal(true);
    const plan = subscriptionData.find((item) => item?._id === id);
    const memberPlanTypeId =
      memberDetails.plans[memberDetails.plans.length - 1].planTypeId;
    const updatedPlanType = plan.planType.filter(
      (item) => item?._id !== memberPlanTypeId
    );
    const updatedPlan = { ...plan, planType: updatedPlanType };
    setSelectedPlan(updatedPlan);
  };

  //upload ChangePlan patch the data
  const updateChangingPlan = (id) => {
    const planItem = subscriptionData.find((item) =>
      selectedPlan?._id.includes(item?._id)
    );
    const filteredPlanType = planItem.planType.filter(
      (type) => type?._id === selectedPlanType
    );
    const plansArray = filteredPlanType.map((type) => ({
      planId: planItem?._id,
      planTypeId: type?._id,
      amount: type.amount,
      currency: "INR",
    }));
    const data = {
      plans: plansArray,
    };
    updateChangePlan({ id, data }).then((res) => {
      if (res?.data?.status) {
        const data = res?.data?.data?.purchaseData;
        setValue("amount", data?.amount);
        setValue("currency", data?.currency);
        setValue("orderId", data?.orderId);
        setValue("paymentStatus", 0);
        setIsPlanUpdated(true);
      }
    });
  };

  //close Modal
  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    if (isPlanUpdated) {
      cancelRenewalFn();
      setIsPlanUpdated(false);
    }
    const found = subscriptionData.find(
      (plan) =>
        plan?._id ===
        memberDetails.plans.findLast(da => da.isPaid === 1)?.planId
    );
    setSelectedPlan(found);
    setOpenModal(false);
  };

  //to patch the membership name
  const showName = (name) => {
    if (name === "0") {
      return "Individual Teacher";
    } else if (name === "1") {
      return "Dual Teacher";
    } else if (name === "2") {
      return "Individual Student";
    } else if (name === "3") {
      return "Institutional";
    } else if (name === "4") {
      return "Corporate Supporter";
    } else {
      return name;
    }
  };

  //patch based on the Condition selet plantype amout
  useEffect(() => {
    if (selectedPlan && selectedPlan.planType?.length > 0) {
      setSelectedPlanType(
        selectedPlan.planName === "0"
          ? selectedPlan.planType.filter((i) => i.planTypeName !== "Annual")[0]
            ?._id
          : selectedPlan.planType[0]?._id
      );
      const amount = selectedPlan.planName === "0"
        ? selectedPlan.planType.filter(
          (i) => i.planTypeName !== "Annual"
        )[0].offer > 0
          ? selectedPlan.planType.filter(
            (i) => i.planTypeName !== "Annual"
          )[0].offerAmount
          : selectedPlan.planType.filter(
            (i) => i.planTypeName !== "Annual"
          )[0].amount
        : selectedPlan.planType[0]?.offer > 0
          ? selectedPlan.planType[0]?.offerAmount
          : selectedPlan.planType[0]?.amount
      const memberPlan = memberDetails?.plans.findLast(pl => pl.isPaid === 1)
      const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(memberPlan?.planEndDate)
      if (planExpired) {
        setSelectedAmount(amount);
      }
      else {
        setSelectedAmount(amount - memberPlan?.amount);
      }
    }
  }, [selectedPlan, memberDetails?.plans]);

  //patch based on the Condition memberplan type
  useEffect(() => {
    if (memberScope === "PORTAL_MEMBER") {
      const memberPlan = memberDetails?.plans.findLast(pl => pl.isPaid === 1)?.planId
      const memberPlanType = memberDetails &&
        memberDetails?.plans.findLast(pl => pl.isPaid === 1)?.planTypeId;
      const filteredPlanType = subscriptionData.find(pl => pl._id === memberPlan)?.planType?.filter((item) =>
        memberPlanType === item?._id
      );
      setMemberPlanType(filteredPlanType);
    }
  }, [memberDetails, memberScope, subscriptionData]);

  const isWithinDateRange = (sDate, eDate) => {
    const startDate = new Date(sDate);
    const endDate = new Date(eDate);
    const today = new Date();

    // Strip time part for an accurate date-only comparison (optional)
    const start = new Date(startDate.toDateString());
    const end = new Date(endDate.toDateString());
    const now = new Date(today.toDateString());

    const isWithinRange = now >= start && now <= end;
    const memeberPlan = memberDetails?.plans.findLast(pl => pl.isPaid === 1)
    const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(memeberPlan?.planEndDate);
    return isWithinRange && !planExpired;
  };
  //handle Log Out
  const handleLogout = () => {
    dispatch(logOut());
    navigate("/login", { replace: true, state: { from: location } });
    dispatch(setMemberDetails({}));
    dispatch(setRoleDetails({}));
    dispatch(setSigRoleDetails({}));
    dispatch(setChapterDetails({}));
    dispatch(setSigDetails({}));
    dispatch(api.util.resetApiState());
  };
  const disableChangePlan = (plan) => {
    const memberPlan = memberDetails?.plans.findLast(pl => pl?.isPaid === 1)
    const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(memberPlan?.planEndDate);
    return plan.planType.length > 1 && (plan.planType.some(pl => pl.duration > (memberPlanType && memberPlanType[0]?.duration)) || planExpired)
  }
  return (
    <Box>
      <div className="join-eltai-container">
        <div className="join-eltai-nav-bar">
          <TopHeader />
        </div>
        <div className="pt-5">
          <div className="chapter-heading">
            <h2 className="text-center title-font text-light py-3 mt-1">
              Subscription
            </h2>
          </div>
        </div>
      </div>
      <Box
        sx={{
          width: "100%",
          height: "max-height",
          backgroundImage: `url(${joineltaibackground})`,
          backgroundPosition: "center ",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="p-md-5 p-3 overallPadding"
      >
        <Container maxWidth={"xl"}>
          <div className="Join-eltai-Title ">
            <div className="text-center">
              {" "}
              <p className="Join-eltai-Title-sub mt-4 text-center content-font">
                REVISED RATES OF SUBSCRIPTION (W.E.F. 1st January,2025)
              </p>
            </div>
          </div>
          {isExpired && location?.pathname.includes("renew") && (
            <div>
              <div className="text-center">
                {" "}
                <p className="Join-eltai-Title-sub bg-danger-subtle mt-4 text-center content-font">
                  <NotificationImportant /> Your{" "}
                  {planType &&
                    selectedPlan &&
                    planType.find(
                      (plan) => plan?.planId === selectedPlan?.planName
                    )?.planName}{" "}
                  Subscription is expired please renew or change plan to
                  continue using ELTAI services.
                </p>
              </div>
            </div>
          )}
        </Container>
        <div className=" subscribtion-card mt-5">
          <Container maxWidth={"xl"}>
            <Grid>
              <Grid
                container
                spacing={{ xs: 4, md: 3.5 }}
                columns={{ xs: 4, sm: 4, md: 12 }}
              >
                {subscriptionData && subscriptionData?.length !== 0 ? (
                  subscriptionData.map((sub, index) => {
                    return isWithinDateRange(sub?.startDate, sub?.endDate) ? (
                      <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                        <div
                          className={
                            hoveredPrice === index
                              ? " card-container1"
                              : " card-container1"
                          }
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={() => handleMouseLeave(index)}
                        >
                          <CardContent className="customScroll">
                            <div className="text-center">
                              <p className="Subscribtion-card-heading menus-green-color fw-bold alata-bold title-font">
                                {showName(sub.planName)}
                              </p>
                            </div>
                            <div className="subscribtion-prize">
                              {sub?.planType &&
                                sub?.planType?.map((plan, i) => (
                                  <Container
                                    sx={{ mt: 1 }}
                                    maxWidth="lg"
                                    key={i}
                                  >
                                    <div className="row justify-content-center align-items-center">
                                      <div className="col-12 content-font">
                                        {plan?.offer > 0 ||
                                          plan?.discount > 0 ? (
                                          <p className="d-flex justify-content-between align-items-center signika fs-4 text-secondary">
                                            <span>
                                              {plan.planTypeName}(
                                              {plan?.duration}{plan?.duration > 1 ? 'years' : 'year'}) :
                                            </span>{" "}
                                            <span className="text-danger-50 text-decoration-line-through">
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan.amount}
                                            </span>
                                          </p>
                                        ) : (
                                          <p className="d-flex justify-content-between align-items-center signika fs-4 text-secondary">
                                            <span>
                                              {plan.planTypeName}(
                                              {plan?.duration}{plan?.duration > 1 ? 'years' : 'year'}) :
                                            </span>{" "}
                                            <span>
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan.amount}
                                            </span>
                                          </p>
                                        )}
                                        {plan?.offer > 0 &&
                                          plan?.discount > 0 ? (
                                          <p className="d-flex justify-content-between signika align-items-center fs-4 text-secondary">
                                            <span>
                                              {" "}
                                              Offer ({plan?.offer}%) :{" "}
                                            </span>
                                            <span className="text-danger-50">
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan?.offerAmount}
                                            </span>
                                          </p>
                                        ) : (
                                          plan?.offer > 0 && <p className="d-flex justify-content-between signika align-items-center fs-4 text-secondary">
                                            <span>
                                              {" "}
                                              Offer ({plan?.offer}%) :{" "}
                                            </span>
                                            <span>
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan?.offerAmount}
                                            </span>
                                          </p>
                                        )}
                                        {plan?.discount > 0 && (
                                          <p className="d-flex justify-content-between signika align-items-center fs-4 text-secondary">
                                            <span>
                                              {" "}
                                              Renewal Discount ({plan?.discount}
                                              %):{" "}
                                            </span>
                                            <span className="text-secondary-new fw-semibold">
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan?.discountAmount}
                                            </span>
                                          </p>
                                        )}
                                        {/* </div> */}
                                        {i < sub?.planType.length - 1 && <hr />}
                                      </div>
                                      {(!(
                                        memberScope === "PORTAL_SUPER_ADMIN" ||
                                        memberScope === "PORTAL_SIG_ADMIN" ||
                                        memberScope ===
                                        "PORTAL_CHAPTER_ADMIN" ||
                                        memberScope === "PORTAL_MEMBER"
                                      ) ||
                                        memberScope === undefined ||
                                        memberScope === null) && (
                                          <div className="col-4">
                                            <Tooltip title="Register">
                                              <Button
                                                variant="contained"
                                                className="menus-color"
                                                style={{ width: "100%" }}
                                                onClick={() =>
                                                  handleRegister(
                                                    sub?._id,
                                                    plan?._id
                                                  )
                                                }
                                              >
                                                Register
                                              </Button>
                                            </Tooltip>
                                          </div>
                                        )}
                                    </div>
                                  </Container>
                                ))}
                              <div className="text-center">
                                {memberScope === "PORTAL_MEMBER" && (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {!hideRenew && (
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        className="menus-green-btn"
                                        style={{
                                          marginRight: "10px",
                                          borderRadius: 0,
                                        }}
                                        disabled={disableRenew}
                                        onClick={() =>
                                          handleOpen(memberDetails?._id)
                                        }
                                      >
                                        Renewal
                                      </Button>
                                    )}
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      className="menus-green-btn-outline"
                                      style={{ borderRadius: 0 }}
                                      onClick={() => handleOpenModal(sub?._id)}
                                      disabled={!disableChangePlan(sub)}
                                    >
                                      Change Plan
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </CardContent>
                        </div>
                      </Grid>
                    ) : (
                      <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                        <div
                          className={
                            hoveredPrice === index
                              ? " card-container1"
                              : " card-container1"
                          }
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={() => handleMouseLeave(index)}
                        >
                          <CardContent className="customScroll">
                            <div className="text-center">
                              <p className="Subscribtion-card-heading menus-green-color fw-bold alata-bold title-font">
                                {showName(sub.planName)}
                              </p>
                            </div>
                            <div className="subscribtion-prize">
                              {sub?.planType &&
                                sub?.planType?.map((plan, i) => (
                                  <Container
                                    sx={{ mt: 1 }}
                                    maxWidth="lg"
                                    key={i}
                                  >
                                    <div className="row justify-content-center align-items-center">
                                      <div className="col-12 content-font">
                                        {plan?.offer > 0 ? (
                                          <p className="d-flex justify-content-between align-items-center signika fs-4 text-secondary">
                                            <span>
                                              {plan.planTypeName}(
                                              {plan?.duration}{plan?.duration > 1 ? 'years' : 'year'}) :
                                            </span>{" "}
                                            <span className="text-danger-50 text-decoration-line-through">
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan.amount}
                                            </span>
                                          </p>
                                        ) : (
                                          <p className="d-flex justify-content-between align-items-center signika fs-4 text-secondary">
                                            <span>
                                              {plan.planTypeName}(
                                              {plan?.duration}{plan?.duration > 1 ? 'years' : 'year'}) :
                                            </span>{" "}
                                            <span>
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan.amount}
                                            </span>
                                          </p>
                                        )}
                                        {plan?.offer > 0 && (
                                          <p className="d-flex justify-content-between signika align-items-center fs-4 text-secondary">
                                            <span>
                                              {" "}
                                              Offer ({plan?.offer}%) :{" "}
                                            </span>
                                            <span>
                                              {plan.currencyType === 1
                                                ? "$"
                                                : "₹"}
                                              {plan?.offerAmount}
                                            </span>
                                          </p>
                                        )}
                                        {/* </div> */}
                                        {i < sub?.planType.length - 1 && <hr />}
                                      </div>
                                      {(!(
                                        memberScope === "PORTAL_SUPER_ADMIN" ||
                                        memberScope === "PORTAL_SIG_ADMIN" ||
                                        memberScope ===
                                        "PORTAL_CHAPTER_ADMIN" ||
                                        memberScope === "PORTAL_MEMBER"
                                      ) ||
                                        memberScope === undefined ||
                                        memberScope === null) && (
                                          <div className="col-4">
                                            <Tooltip title="Register">
                                              <Button
                                                variant="contained"
                                                className="menus-color"
                                                style={{ width: "100%" }}
                                                onClick={() =>
                                                  handleRegister(
                                                    sub?._id,
                                                    plan?._id
                                                  )
                                                }
                                              >
                                                Register
                                              </Button>
                                            </Tooltip>
                                          </div>
                                        )}
                                    </div>
                                  </Container>
                                ))}
                              <div className="text-center">
                                {memberScope === "PORTAL_MEMBER" && (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {!hideRenew && (
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        className="menus-green-btn"
                                        style={{
                                          marginRight: "10px",
                                          borderRadius: 0,
                                        }}
                                        disabled={disableRenew}
                                        onClick={() =>
                                          handleOpen(memberDetails?._id)
                                        }
                                      >
                                        Renewal
                                      </Button>
                                    )}
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      className="menus-green-btn-outline"
                                      style={{ borderRadius: 0 }}
                                      onClick={() => handleOpenModal(sub?._id)}
                                      disabled={!disableChangePlan(sub)}
                                    >
                                      Change Plan
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </CardContent>
                        </div>
                      </Grid>
                    );
                  })
                ) : (
                  <>
                    <Grid item xs={12} sm={12} md={12}>
                      <div
                        className={
                          "card_join card-container align-items-center d-flex justify-content-center w-100"
                        }
                      >
                        <CardContent>
                          <div className="text-center w-100">
                            <p
                              className={
                                "Subscribtion-card-heading w-100 signika"
                              }
                            >
                              No Active Membership Plans Available
                            </p>
                          </div>
                        </CardContent>
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
              {isExpired && location?.pathname.includes("renew") && (
                <Grid container alignItems={"center"} className="mt-5">
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    className="d-flex justify-content-center"
                  >
                    <Button onClick={handleLogout} className="menus-color">
                      Logout
                    </Button>
                  </Grid>
                </Grid>
              )}
              <Modal
                open={open}
                onClose={handleClose}
                disableEscapeKeyDown
                disableEnforceFocus
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <div
                  style={style}
                  className="d-flex align-items-center flex-column gap-3"
                >
                  <form>
                    <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
                      <span
                        style={{
                          backgroundColor: "rgb(16, 78, 41)",
                          color: "white",
                          padding: "4px 8px",
                        }}
                      >
                        Renewal
                      </span>
                    </h4>
                    <div
                      className="mt-3 mx-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FormControl variant="outlined" style={{ minWidth: 200 }}>
                        <InputLabel>Plan</InputLabel>
                        <Select
                          labelId="plan"
                          id="plan"
                          label="Plan"
                          value={selectedPlan?._id || ""}
                          disabled
                        >
                          <MenuItem selected value={selectedPlan?._id}>
                            {
                              planType.find(
                                (plan) =>
                                  selectedPlan?.planName === plan?.planId
                              )?.planName
                            }
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{ marginLeft: "20px", minWidth: 200 }}
                      >
                        <InputLabel>Plan Type</InputLabel>
                        <Select
                          labelId="plantype"
                          id="plantype"
                          label="Plan Type"
                          value={
                            memberPlanType?.length > 0
                              ? memberPlanType[0]?._id
                              : ""
                          }
                          disabled
                        >
                          {memberPlanType?.map((item, index) => (
                            <MenuItem key={index} value={item?._id}>
                              {item?.planTypeName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{ marginLeft: "20px", minWidth: 200 }}
                      >
                        <TextField
                          label="Amount"
                          {...register("amount")}
                          disabled
                        />
                      </FormControl>
                    </div>
                    <div
                      className="mt-3"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={cancelRenewalFn}
                        style={{ marginRight: "10px", borderRadius: 0 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="menus-color"
                        variant="contained"
                        color="success"
                        onClick={handlePayment}
                        disabled={paymentStatus}
                        style={{ borderRadius: "0px" }}
                      >
                        {paymentStatus ? "Paid" : "Pay Now"}
                      </Button>
                    </div>
                  </form>
                </div>
              </Modal>

              <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <div
                  style={style}
                  className="d-flex align-items-center flex-column gap-3"
                >
                  <form>
                    <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
                      <span
                        style={{
                          backgroundColor: "rgb(16, 78, 41)",
                          color: "white",
                          padding: "4px 8px",
                        }}
                      >
                        Change Plan
                      </span>
                    </h4>
                    <div
                      className="mt-3 mx-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FormControl variant="outlined" style={{ minWidth: 200 }}>
                        <InputLabel>Plan</InputLabel>
                        <Select
                          labelId="plan"
                          id="plan"
                          label="Plan"
                          value={selectedPlan?._id || ""}
                          disabled
                        >
                          <MenuItem selected value={selectedPlan?._id}>
                            {selectedPlan &&
                              planType.find(
                                (item) =>
                                  item?.planId === selectedPlan?.planName
                              )?.planName}
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{ marginLeft: "20px", minWidth: 200 }}
                      >
                        <InputLabel>Plan Type</InputLabel>
                        <Select
                          labelId="plantype"
                          id="plantype"
                          label="Plan Type"
                          value={selectedPlanType}
                          disabled={isPlanUpdated}
                          onChange={(e) => {
                            const selectedType = selectedPlan?.planType.find(
                              (type) => type?._id === e.target.value
                            );
                            setSelectedPlanType(e.target.value);
                            const memberPlan = memberDetails?.plans.findLast(pl => pl.isPaid === 1)
                            const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(memberPlan?.planEndDate)
                            const amount = selectedType?.offer > 0
                              ? selectedType?.offerAmount
                              : selectedType?.amount
                            if (planExpired) {
                              setSelectedAmount(amount);
                            }
                            else {
                              setSelectedAmount(amount - memberPlan?.amount);
                            }
                          }}
                        >
                          {selectedPlan?.planType?.map((item, index) =>
                            selectedPlan?.planName === "0" &&
                              item.planTypeName === "Annual" ? null : (
                              <MenuItem key={index} value={item?._id}>
                                {item?.planTypeName}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{ marginLeft: "20px", minWidth: 200 }}
                      >
                        <TextField
                          label="Amount"
                          value={selectedAmount}
                          disabled
                        />
                      </FormControl>
                    </div>
                    <div
                      className="mt-3"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={handleCloseModal}
                        disabled={changePlanLoading}
                        style={{ marginRight: "10px", borderRadius: 0 }}
                      >
                        Cancel
                      </Button>
                      {!isPlanUpdated ? (
                        <Button
                          className="menus-color"
                          variant="contained"
                          color="success"
                          style={{ borderRadius: 0 }}
                          onClick={() => updateChangingPlan(memberDetails?._id)}
                        >
                          Change Plan
                        </Button>
                      ) : (
                        <Button
                          className="menus-color"
                          variant="contained"
                          color="success"
                          onClick={handlePayment}
                          disabled={paymentStatus === 1}
                          style={{ borderRadius: 0 }}
                        >
                          {paymentStatus === 1 ? "Paid" : "Pay Now"}
                        </Button>
                      )}
                    </div>
                  </form>
                </div>
              </Modal>
            </Grid>
          </Container>
        </div>
        {/* <div className="subscribtion-important-container  ">
          <Container maxWidth={"lg"}>
            <div
              className="card mt-5 important-subscribtion-card "
              style={{ backgroundColor: "#ffff" }}
            >
              <span
                style={{ left: "8%", marginTop: "30px" }}
                className="position-absolute top-0 translate-middle badge announcement"
              >
                <img
                  src={joineltai1}
                  alt="sub"
                  className="subcribtion-important-image"
                />
              </span>
              <div className="card-body">
                {importantnews.map((news, i) => (
                  <div key={i}>
                    <div className="important-news">
                      <Container maxWidth={"lg"}>
                        <img src={joineltai2} alt="sub" />

                        <p> {news.news}</p>
                      </Container>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </div> */}
        {/* <div className="Bank-Details p-md-5 ">
          <div className="container-lg bank-details-card-body ">
            <div
              className="card mt-5   w-75 mx-auto"
              style={{ backgroundColor: "#ffff" }}
            >
              <div className="card-body ">
                <div className="Bank-details-title">
                  <img src={joineltai3} alt="sub" />
                  <span
                    className="Bank-title fw-bold fs-3"
                    style={{ marginLeft: "10px" }}
                  >
                    Bank <span className="fw-normal">Account</span>
                  </span>
                </div>
                <div className="row align-items-center justify-content-center">
                  <div
                    className="col-md-4 border-primary p-3 bankNameDetails"
                    style={{ marginTop: "33px" }}
                  >
                    Bank Name
                  </div>
                  <div
                    className="col-md-8 bankName-details p-3 pt-2 "
                  >
                    SBI EAST Mada Street, Villivakkam, Chennai-49
                  </div>
                </div>
                <div className="row align-items-center justify-content-center">
                  <div
                    className="col-md-4 border-primary p-3 bankNameDetails"
                    style={{ marginTop: "33px" }}
                  >
                    Account Number
                  </div>
                  <div
                    className="col-md-8 bankName-details p-3 pt-2"
                    style={{ height: "60px" }}
                  >
                    30870397943
                  </div>
                </div>
                <div className="row align-items-center justify-content-center">
                  <div
                    className="col-md-4 border-primary p-3 bankNameDetails"
                    style={{ marginTop: "33px" }}
                  >
                    IFSC Code
                  </div>
                  <div
                    className="col-md-8 bankName-details p-3 pt-2"
                    style={{ height: "60px" }}
                  >
                    SBIN0007108
                  </div>
                </div>
                <div className="row align-items-center justify-content-center">
                  <div
                    className="col-md-4 border-primary p-3 bankNameDetails"
                    style={{ marginTop: "33px" }}
                  >
                    MICR
                  </div>
                  <div
                    className="col-md-8 bankName-details p-3 pt-2"
                    style={{ height: "60px" }}
                  >
                    600002058
                  </div>
                </div>
                <div className="row align-items-center justify-content-center">
                  <div
                    className="col-md-4 border-primary p-3 bankNameDetails"
                    style={{ marginTop: "33px" }}
                  >
                    Branch Code
                  </div>
                  <div
                    className="col-md-8 bankName-details p-3 pt-2"
                    style={{ height: "60px" }}
                  >
                    007108
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </Box>
    </Box>
  );
};

export default JoinEltai;
